<template>
  <div id="ordermanager">
    <h4>ユーザー一括登録CSVアップロード</h4>
    <div>
      <input ref="fileInput" type="file" multiple="multiple" accept=".csv" @change="onUploadFileChange" />
      <button @click="uploadUserDataCsv" type="button" class="main_btn">アップロード</button>
      <div class="info_message" v-if="message">{{ message }}</div>
      <div class="error_message" v-if="fieldErrorMessages.duplicate">{{ fieldErrorMessages.duplicate }}</div>
      <div class="error_message" v-if="fieldErrorMessages.required">{{ fieldErrorMessages.required }}</div>
      <div class="error_message" v-if="fieldErrorMessages.valid">{{ fieldErrorMessages.valid }}</div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../constants/App'
import {OBJECT_TYPE} from '../constants/Type'
import * as Api from '../utils/Api'
import * as App from '../utils/App'
import LoadingModal from '../components/common/LoadingModal'

export default {
  components: {
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      // *****************************************************************
      // 空間データCSVアップロード
      // *****************************************************************
      uploadFiles: [],
      /** アップロードファイルタイプ */
      uploadFileObjectType: OBJECT_TYPE.UNIT,
      uploadFileObjectTypeList: [ OBJECT_TYPE.UNIT, OBJECT_TYPE.COMBINE, OBJECT_TYPE.COMBINESET, OBJECT_TYPE.SETPLAN, OBJECT_TYPE.OHTANI ],
      fieldErrorMessages: {
        required: '',
        valid: '',
        duplicate: ''
      },
      message: '',
      errorMessage: ''
    }
  },
  methods: {
    onUploadFileChange: function (event) {
      event.preventDefault()
      this.clearMessages()
      this.uploadFiles = event.target.files
    },
    uploadUserDataCsv: function (event) {
      this.$refs.loadingModalRef.showModal(true)
      event.preventDefault()
      this.clearMessages()

      // 送信データ
      let payload = new FormData()
      for (let i = 0; i < this.uploadFiles.length; i++) {
        payload.append('files', new Blob([this.uploadFiles[i]], {type: 'application/csv'}), this.uploadFiles[i].name)
      }
      payload.append('objectType', this.uploadFileObjectType.code)
      axios.post(API_URL.UPLOAD + '/csv/user-data', payload
      ).then(response => {
        if (response.data.errorMessage) {
          let modalData = {
            title: 'ユーザーデータエラー',
            messages: response.data.errorMessage.split(/\r?\n/g),
            messageType: 'error',
            textAlign: 'left',
            onOk: this.getEditingFileData
          }
          App.showModal(modalData)
        } else {
          this.message = response.data.infoMessage
          this.clearFiles()
          this.$emit('fileUploadCallback')
        }
        this.$refs.loadingModalRef.showModal(false)
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        this.$set(this.fieldErrorMessages, 'duplicate', error.response.data.errorMessage)
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    clearFiles: function () {
      this.$refs.fileInput.value = ''
      this.uploadFiles = []
    },
    clearMessages: function () {
      this.message = ''
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {
        required: '',
        valid: '',
        duplicate: ''
      }
    }
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/main/js/pages/OrderManager.vue